import axios from '@/plugins/axios'

/**
 * 文件上传
 * @param {File} file - 要上传的文件
 * @returns {Promise}
 */
export function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return axios({
    url: 'https://api.ding.cvoon.com/base/manage/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
} 